import { CoreOrganizationsAllName } from './name';
import { getAllOrganizations } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreOrganizationsAllGetAsyncSlice = createGetAsyncSlice({
	name: CoreOrganizationsAllName,
	receive: true,
	request: false,
	requestHandler: (request) => getAllOrganizations(request).then(
		(response) => ({
			...response,
			data: response.data ? {
				results: response.data.organizations
			} : undefined
		})
	),
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
